import {
  API_CERTIFICACOES,
  API_COMPRAS_MADEIRA,
  API_ESTOQUE_MADEIRA,
  API_FORNECEDORES,
  API_ITENS_COMPRA_MADEIRA,
  API_LOTES_MADEIRA,
  API_UNIDADES_MEDIDA,
  API_TIPOS_MADEIRA,
  API_TIPOS_TRATAMENTO,
  API_TRATAMENTOS_MADEIRA,
} from '../api/apiConfig';
import {
  Certificacao,
  CompraMadeira,
  EstoqueMadeira,
  Fornecedor,
  ItemCompraMadeira,
  LoteMadeira,
  TipoMadeira,
  TipoTratamento,
  TratamentoMadeira,
  UnidadeMedida,
} from '../types/aquisicao';
import { createCrudService } from './crudFactory';

export const tiposMadeiraService = createCrudService<TipoMadeira>(API_TIPOS_MADEIRA);
export const unidadesMedidaService =
  createCrudService<UnidadeMedida>(API_UNIDADES_MEDIDA);
export const fornecedoresService = createCrudService<Fornecedor>(API_FORNECEDORES);
export const certificacoesService = createCrudService<Certificacao>(API_CERTIFICACOES);
export const tiposTratamentoService =
  createCrudService<TipoTratamento>(API_TIPOS_TRATAMENTO);
export const comprasMadeiraService =
  createCrudService<CompraMadeira>(API_COMPRAS_MADEIRA);
export const itensCompraMadeiraService =
  createCrudService<ItemCompraMadeira>(API_ITENS_COMPRA_MADEIRA);
export const lotesMadeiraService = createCrudService<LoteMadeira>(API_LOTES_MADEIRA);
export const tratamentosMadeiraService =
  createCrudService<TratamentoMadeira>(API_TRATAMENTOS_MADEIRA);
export const estoqueMadeiraService =
  createCrudService<EstoqueMadeira>(API_ESTOQUE_MADEIRA);
